import {DI_TOKENS} from '@/di/di.tokens';
import {LeaderBoardStatusType, LeagueType} from '@/stores/LeaderBoardStore/LeaderBoardStore.constants';
import {Player} from '@/stores/LeaderBoardStore/LeaderBoardStore.types';

import {injected} from 'brandi';

import {LeaderBoardResult, LeagueResult} from '@/services/ProjectApi/types';

import {ProjectDate} from '../../ProjectDate/ProjectDate';

export class LeaderBoardMocks {
  private leaderboard: Player[];
  private status: LeaderBoardStatusType;

  constructor(private readonly projectDate: ProjectDate) {
    this.leaderboard = LEADERBOARD_MOCKS;
    this.status = LeaderBoardStatusType.Active;
  }

  public getLeaderBoardResult = (): LeaderBoardResult => {
    this.updateLeaderboardRanks();

    return {
      status: this.status,
      leaderboard: this.leaderboard,
    };
  };

  public updateUserScore(score: number): void {
    this.leaderboard = this.leaderboard.map((p) => {
      if (p.isUser) {
        return {
          ...p,
          score,
        };
      }

      return p;
    });

    this.updateLeaderboardRanks();
  }

  public getLeagueResult = (): LeagueResult => {
    const leagueRecalculationAt = this.projectDate.date;
    leagueRecalculationAt.setDate(leagueRecalculationAt.getDate() + 7);

    const baseProps = {
      nextRecalculationAt: leagueRecalculationAt.toISOString(),
      isRecalculationInProgress: false,
    };

    if (this.status === LeaderBoardStatusType.New) {
      return {
        ...baseProps,
        league: null,
        score: 0,
      };
    }

    if (this.status === LeaderBoardStatusType.Pending) {
      return {
        ...baseProps,
        league: LeagueType.Gold,
        score: 10,
      };
    }

    return {
      ...baseProps,
      league: LeagueType.Gold,
      score: this.leaderboard.find((player) => player.isUser)?.score || 0,
    };
  };

  private updateLeaderboardRanks = (): void => {
    this.leaderboard = this.leaderboard
      .slice()
      .sort((a, b) => b.score - a.score)
      .map((p, index) => ({
        ...p,
        rank: index + 1,
      }));
  };
}

injected(LeaderBoardMocks, DI_TOKENS.projectDate);

export function getLeaderBoardMock(status: LeaderBoardStatusType): LeaderBoardResult {
  return {
    status,
    leaderboard: LEADERBOARD_MOCKS,
  };
}

export const LEADERBOARD_MOCKS: Player[] = [
  {
    firstName: 'Вы',
    lastName: '',
    score: 0,
    isUser: true,
    rank: 33,
  },
  {
    firstName: 'Владислав',
    lastName: 'В.',
    score: 99733,
    isUser: false,
    rank: 3,
  },
  {
    firstName: 'Виктория',
    lastName: 'Ф.',
    score: 130689,
    isUser: false,
    rank: 1,
  },
  {
    firstName: 'Артём',
    lastName: 'Н.',
    score: 95450,
    isUser: false,
    rank: 4,
  },
  {
    firstName: 'Евгения',
    lastName: 'Л.',
    score: 114540,
    isUser: false,
    rank: 2,
  },
  {
    firstName: 'Яна',
    lastName: 'Г.',
    score: 87394,
    isUser: false,
    rank: 5,
  },
  {
    firstName: 'Виктор',
    lastName: 'К.',
    score: 69765,
    isUser: false,
    rank: 6,
  },
  {
    firstName: 'Олег',
    lastName: 'М.',
    score: 66344,
    isUser: false,
    rank: 7,
  },
  {
    firstName: 'Алексей',
    lastName: 'О.',
    score: 56761,
    isUser: false,
    rank: 8,
  },
  {
    firstName: 'Антон',
    lastName: 'П.',
    score: 52761,
    isUser: false,
    rank: 10,
  },
  {
    firstName: 'Игорь',
    lastName: 'М.',
    score: 50761,
    isUser: false,
    rank: 11,
  },
  {
    firstName: 'Павел',
    lastName: 'Н.',
    score: 55761,
    isUser: false,
    rank: 9,
  },
  {
    firstName: 'Валерия',
    lastName: 'Н.',
    score: 49761,
    isUser: false,
    rank: 12,
  },
  {
    firstName: 'Ирина',
    lastName: 'Н.',
    score: 45114,
    isUser: false,
    rank: 13,
  },
  {
    firstName: 'Виталий',
    lastName: 'А.',
    score: 40114,
    isUser: false,
    rank: 14,
  },
  {
    firstName: 'Вадим',
    lastName: 'Г.',
    score: 39114,
    isUser: false,
    rank: 15,
  },
  {
    firstName: 'Диана',
    lastName: 'Ж.',
    score: 38114,
    isUser: false,
    rank: 16,
  },
  {
    firstName: 'Денис',
    lastName: 'Ф.',
    score: 29114,
    isUser: false,
    rank: 17,
  },
  {
    firstName: 'Артур',
    lastName: 'Ш.',
    score: 24114,
    isUser: false,
    rank: 18,
  },
  {
    firstName: 'Евгений',
    lastName: 'Ф.',
    score: 24014,
    isUser: false,
    rank: 19,
  },
  {
    firstName: 'Николай',
    lastName: 'З.',
    score: 23014,
    isUser: false,
    rank: 20,
  },
  {
    firstName: 'Александра',
    lastName: 'Н.',
    score: 20014,
    isUser: false,
    rank: 21,
  },
  {
    firstName: 'Михаил',
    lastName: 'Т.',
    score: 19043,
    isUser: false,
    rank: 22,
  },
  {
    firstName: 'Мария',
    lastName: 'Н.',
    score: 18004,
    isUser: false,
    rank: 23,
  },
  {
    firstName: 'Сергей',
    lastName: 'Ф.',
    score: 17464,
    isUser: false,
    rank: 24,
  },
  {
    firstName: 'Артём',
    lastName: 'А.',
    score: 15093,
    isUser: false,
    rank: 25,
  },
  {
    firstName: 'Ольга',
    lastName: 'Н.',
    score: 14989,
    isUser: false,
    rank: 26,
  },
  {
    firstName: 'Диана',
    lastName: 'Н.',
    score: 13000,
    isUser: false,
    rank: 27,
  },
  {
    firstName: 'Андрей',
    lastName: 'Н.',
    score: 10242,
    isUser: false,
    rank: 28,
  },
  {
    firstName: 'Александр',
    lastName: 'А.',
    score: 5012,
    isUser: false,
    rank: 29,
  },
  {
    firstName: 'Алексей',
    lastName: 'Н.',
    score: 3902,
    isUser: false,
    rank: 30,
  },
  {
    firstName: 'Артём',
    lastName: 'А.',
    score: 740,
    isUser: false,
    rank: 31,
  },
  {
    firstName: 'Ксения',
    lastName: 'Е.',
    score: 1,
    isUser: false,
    rank: 32,
  },
];
